"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var _kernel_container_1 = __importDefault(require("../../../container"));
var history_1 = require("../../selectors/history");
var mediafiles_1 = require("../../selectors/mediafiles");
var playlist_1 = require("../../selectors/playlist");
var mediafilesMeta_1 = require("../../stores/mediafilesMeta");
function cleanupUnusedMediafiles() {
    var action = function (dispatch, getState) {
        var settings = _kernel_container_1.default.get("SETTINGS");
        var state = getState();
        var historyMediafileIds = (0, history_1.selectHistoryItemsWithMediafilesWithLimit)(state, settings === null || settings === void 0 ? void 0 : settings.getSetting("HISTORY_ITEMS_LIMIT", 30)).map(function (item) { return item.mediafileId; });
        var requiredMediafileIds = new Set(__spreadArray(__spreadArray(__spreadArray([], __read((0, playlist_1.selectPlaylistMediafileIds)(state)), false), __read((0, mediafiles_1.selectRequiredMediafileIds)(state)), false), __read(historyMediafileIds), false));
        var toRemove = Object.values((0, mediafiles_1.selectMediafiles)(state))
            .filter(function (mediafile) { return !requiredMediafileIds.has(mediafile.id); })
            .map(function (mediafile) { return ({ id: mediafile.id, type: "totalCleanup" }); });
        dispatch(mediafilesMeta_1.setMediafilesCleanupQueue.apply(void 0, __spreadArray([], __read(toRemove), false)));
    };
    action.type = cleanupUnusedMediafiles.type;
    return action;
}
exports.default = cleanupUnusedMediafiles;
cleanupUnusedMediafiles.type = "cleanupUnusedMediafiles";
//# sourceMappingURL=cleanupUnusedMediafiles.js.map